export default "__VITE_ASSET__3c3ee570__"